import { useEffect, useMemo, useState } from 'react';
import { fetchValues } from './seriesApi';
import { sliceValues } from './slicing';

/** The values of a table for a choice's fixed dimensions, and the slice they make. */
export default function useSlice(instanceId, table, choice) {
  const [values, setValues] = useState(null);
  const [error, setError] = useState(null);
  const fixedKey = JSON.stringify(choice?.fixed || {});
  useEffect(() => {
    let live = true;
    setValues(null);
    if (!instanceId || !table || !choice) return undefined;
    fetchValues(instanceId, table.id, choice.fixed)
      .then((v) => { if (live) { setValues(v); setError(null); } })
      .catch((e) => { if (live) setError(e); });
    return () => { live = false; };
  }, [instanceId, table?.id, fixedKey]); // eslint-disable-line react-hooks/exhaustive-deps
  const slice = useMemo(() => (table && choice && values ? sliceValues(table, values, choice) : null), [table, choice, values]);
  return { slice, values, error };
}
